var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "-247 370.9 100 100",
    style: {
      enableBackground: "new -247 370.9 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-147.7,390.4c-0.3-5.5-4.7-9.8-10-9.8h-78.8c-5.6,0-10.1,4.6-10.1,10.2v42.3c0,5.5,4.6,10.2,10.1,10.2h2.3v14.1 c0,1.5,0.8,2.8,2.2,3.4c0.6,0.3,1.1,0.4,1.7,0.4c1,0,1.9-0.4,2.6-1.1l17.3-16.9h52.8c5.4,0,10-4.7,10-10.2v-42.6L-147.7,390.4z  M-152.7,433.1c0,2.8-2.3,5.2-5,5.2h-54.8l-16.7,16.3v-16.3h-7.3c-2.7,0-5.1-2.4-5.1-5.2v-42.3c0-2.8,2.3-5.2,5.1-5.2h78.8 c2.7,0,4.8,2.2,5,5V433.1z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-222.7,399.2h50.5c1.4,0,2.5-1.1,2.5-2.5l0,0c0-1.4-1.1-2.5-2.5-2.5h-50.5c-1.4,0-2.5,1.1-2.5,2.5l0,0 C-225.2,398.1-224.1,399.2-222.7,399.2z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-222.7,408.7h50.5c1.4,0,2.5-1.1,2.5-2.5l0,0c0-1.4-1.1-2.5-2.5-2.5h-50.5c-1.4,0-2.5,1.1-2.5,2.5l0,0 C-225.2,407.6-224.1,408.7-222.7,408.7z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-222.7,418.2h50.5c1.4,0,2.5-1.1,2.5-2.5l0,0c0-1.4-1.1-2.5-2.5-2.5h-50.5c-1.4,0-2.5,1.1-2.5,2.5l0,0 C-225.2,417.1-224.1,418.2-222.7,418.2z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-222.7,427.7h29.6c1.4,0,2.5-1.1,2.5-2.5l0,0c0-1.4-1.1-2.5-2.5-2.5h-29.6c-1.4,0-2.5,1.1-2.5,2.5l0,0 C-225.2,426.6-224.1,427.7-222.7,427.7z",
    fill: "#cccccc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.1a0fc609c24929e87aa53ca7eb877913.svg";
export { ForwardRef as ReactComponent };